import { render, staticRenderFns } from "./authStatusResult.vue?vue&type=template&id=1cc0014e&scoped=true"
import script from "./authStatusResult.vue?vue&type=script&lang=js"
export * from "./authStatusResult.vue?vue&type=script&lang=js"
import style0 from "./authStatusResult.vue?vue&type=style&index=0&id=1cc0014e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc0014e",
  null
  
)

export default component.exports